import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-italic",
  templateUrl: "./med-icon-italic.component.html",
})
export class MedIconItalicComponent extends SvgMixinComponent {}
